import {
  type PomodoroSession,
  PomodoroSessionSchema,
  type PomodoroSettings,
  PomodoroSettingsSchema,
  type PomodoroStateView,
} from '../model/schema'

export interface PomodoroSettingsDto {
  employee_id: string
  work_minutes: number
  break_minutes: number
}

export interface PomodoroSessionDto {
  id: string
  employee_id: string
  task_id?: string | null
  work_minutes: number
  break_minutes: number
  phase: string
  phase_started_at: string
  phase_ends_at: string
  state: string
  // omitempty на бэке: присутствует только у paused-сессии.
  remaining_seconds?: number
  created_at: string
  updated_at: string
}

export interface PomodoroStateDto {
  session?: PomodoroSessionDto | null
  settings: PomodoroSettingsDto
}

export function toPomodoroSettings(dto: PomodoroSettingsDto): PomodoroSettings {
  return PomodoroSettingsSchema.parse({
    employeeId: dto.employee_id,
    workMinutes: dto.work_minutes,
    breakMinutes: dto.break_minutes,
  })
}

export function toPomodoroSession(dto: PomodoroSessionDto): PomodoroSession {
  return PomodoroSessionSchema.parse({
    id: dto.id,
    employeeId: dto.employee_id,
    taskId: dto.task_id ?? null,
    workMinutes: dto.work_minutes,
    breakMinutes: dto.break_minutes,
    phase: dto.phase,
    phaseStartedAt: dto.phase_started_at,
    phaseEndsAt: dto.phase_ends_at,
    state: dto.state,
    ...(dto.remaining_seconds !== undefined ? { remainingSeconds: dto.remaining_seconds } : {}),
    createdAt: dto.created_at,
    updatedAt: dto.updated_at,
  })
}

export function toPomodoroState(dto: PomodoroStateDto): PomodoroStateView {
  return {
    session: dto.session ? toPomodoroSession(dto.session) : null,
    settings: toPomodoroSettings(dto.settings),
  }
}
